export const priceCount = (price: number, quantity: number) =>
  (price * quantity).toFixed(2);

export const priceSymbol = (price: number | string): string => {
  if (typeof price === "string") {
    return `$${price}`;
  }
  return Number.isInteger(price) ? `$${price}` : `$${price.toFixed(2)}`;
};
